/* KMALL09 재입고 알림 — 품절 상품 PDP 신청 폼 (260812)
   문구는 전부 #km-restock-cfg 의 t.* (locale 키)에서 온다 — 리터럴 금지(번역 가능성 유지).
   신청은 Supabase restock-alert(subscribe)로 저장되고, 발송은 콘솔에서 담당자가 승인한다. */
(function () {
  var cfgEl = document.getElementById('km-restock-cfg');
  var btn = document.querySelector('[data-km-restock]');
  if (!cfgEl || !btn) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = CFG.t || {};
  var modal = null, lastFocus = null;

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  /* 담긴 변형이 바뀌었을 수 있으므로 클릭 시점에 폼에서 다시 읽는다 */
  function currentVariant() {
    var form = btn.closest('form');
    var f = form && form.querySelector('[name="id"]');
    var v = f && String(f.value || '').replace(/\D/g, '');
    return v || btn.getAttribute('data-vid');
  }

  function close() {
    if (!modal) return;
    document.removeEventListener('keydown', onKey);
    modal.remove();
    modal = null;
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function open() {
    if (modal) return;
    lastFocus = document.activeElement;

    /* kmall-scope 필수 — --blue/--yellow 등 토큰이 .kmall-scope 안에서만 정의된다.
       모달을 body에 바로 붙이면 그 범위 밖으로 나가 .kmall-btn.primary 배경이 투명해지고
       흰 글씨(흰 배경 위)가 안 보이는 상태가 된다(260813 실사고: "닫기"만 보이고 "알림 신청"이 사라짐). */
    modal = el('div', 'km-rs-wrap kmall-scope');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    var box = el('div', 'km-rs-box');
    var h = el('h3', 'km-rs-h', T.title);
    box.appendChild(h);
    modal.setAttribute('aria-label', T.title || '');

    box.appendChild(el('p', 'km-rs-p', T.desc));

    var name = el('div', 'km-rs-item', btn.getAttribute('data-pt') || '');
    var vt = btn.getAttribute('data-vt');
    if (vt) name.textContent += ' (' + vt + ')';
    box.appendChild(name);

    var lab = el('label', 'km-rs-lab', T.email_label);
    lab.setAttribute('for', 'km-rs-email');
    box.appendChild(lab);

    var input = el('input', 'km-rs-input');
    input.type = 'email';
    input.id = 'km-rs-email';
    input.placeholder = T.email_ph || '';
    input.value = CFG.email || '';
    input.autocomplete = 'email';
    box.appendChild(input);

    var msg = el('div', 'km-rs-msg');
    box.appendChild(msg);

    var row = el('div', 'km-rs-row');
    var submit = el('button', 'kmall-btn primary km-rs-submit', T.submit);
    submit.type = 'button';
    var cancel = el('button', 'kmall-btn ghost', T.cancel);
    cancel.type = 'button';
    row.appendChild(submit);
    row.appendChild(cancel);
    box.appendChild(row);

    box.appendChild(el('p', 'km-rs-priv', T.privacy));

    modal.appendChild(box);
    document.body.appendChild(modal);
    document.addEventListener('keydown', onKey);

    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    cancel.addEventListener('click', close);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit.click(); });
    setTimeout(function () { input.focus(); }, 30);

    submit.addEventListener('click', function () {
      var email = String(input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        msg.className = 'km-rs-msg err';
        msg.textContent = T.bad_email;
        input.focus();
        return;
      }
      submit.disabled = true;
      msg.className = 'km-rs-msg';
      msg.textContent = '';

      fetch(CFG.url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + CFG.key },
        body: JSON.stringify({
          action: 'subscribe',
          email: email,
          variant_id: currentVariant(),
          product_id: btn.getAttribute('data-pid'),
          handle: btn.getAttribute('data-handle'),
          barcode: btn.getAttribute('data-bc'),
          product_title: btn.getAttribute('data-pt'),
          variant_title: btn.getAttribute('data-vt'),
          locale: CFG.locale,
          customer_id: CFG.customerId
        })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (j) {
          if (j && j.ok) {
            box.innerHTML = '';
            var okIco = el('div', 'km-rs-ok-ico', '✓');
            box.appendChild(okIco);
            box.appendChild(el('p', 'km-rs-ok', j.already ? T.already : T.ok));
            var c2 = el('button', 'kmall-btn primary', T.cancel);
            c2.type = 'button';
            c2.addEventListener('click', close);
            box.appendChild(c2);
            setTimeout(function () { c2.focus(); }, 30);
            return;
          }
          submit.disabled = false;
          msg.className = 'km-rs-msg err';
          msg.textContent = (j && j.error === 'BAD_EMAIL') ? T.bad_email
            : (j && j.error === 'TOO_MANY') ? T.too_many
              : T.error;
        })
        .catch(function () {
          submit.disabled = false;
          msg.className = 'km-rs-msg err';
          msg.textContent = T.error;
        });
    });
  }

  btn.addEventListener('click', open);
})();
